import { useState } from "react"
import { useDeleteGGNLocation } from "../../api/useWeatherGGN"
import { GGNLocations } from "../../interfaces/intakes.reports"
import { GGNSingleWeather } from "./GGNSingleWeather"

interface Props {
    reportId: string
    weather: GGNLocations[]
    closeModal: () => void
}

export const GGNWeather = ({ reportId, weather, closeModal }: Props) => {

    const { mutate, isLoading } = useDeleteGGNLocation()
    const [confirm, setConfirm] = useState<boolean>(false)

    const handleDeleteGGN = (ggn_number: string) => {
        mutate({
            reportId,
            ggn_number
        })
    };

    return (

        <>
            {
                confirm
                    ? <button onClick={() => setConfirm(false)}>Close</button>
                    :
                    <div className="modal__botones tw-flex-col">
                        <div className="tw-mb-8">
                            {
                                weather.map(location => (
                                    <GGNSingleWeather key={location.city} location={location} handleDeleteGGN={handleDeleteGGN} isLoading={isLoading}/>
                                ))
                            }
                        </div>
                        <button
                            className={`modal-btn btn-close tw-w-full`}
                            onClick={closeModal}
                        >
                            Close
                        </button>

                    </div>
            }

        </>

    )
}
